export const CloseIcon = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color = '#1A1519', className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
        <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M18 6L6 18M6 6l12 12'></path>
      </svg>
    </span>
  );
};
